export const TAKE_UP_SPACE_HEIGHT = 8;
export const TITLE_BAR_HEIGHT = 40;
export const SELECTION_THROTTLE_TIME = 0;
export const MODEL_THROTTLE_TIME = 10;
export const PLATFORM_PC = 'pc';
